import TennisTable from "./TennisTable";

export const secondPickleBallSection = (n) => {
  return [
    {
      name: "Row 2",
      left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
      right: [
        {
          column1: "One Coat/Two Coats",
          column2: `${15 * n} Gallons / ${30 * n} Gallons`,
        },
        {
          column1: "One Coat/Two Coats",
          column2: `${22.5 * n} Gallons / ${45 * n} Gallons`,
        },
      ],
    },
  ];
};

export const thirdPickleBallSection = (n) => {
  return [
    {
      name: "Row 3",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${30 * n} Gallons` },
        { column1: "Two Coats", column2: `${20 * n} Gallons` },
        { column1: "Two Coats", column2: `${36 * n} Gallons` },
      ],
    },
  ];
};

export const forthPickleBallSection = (n) => {
  return [
    {
      name: "Row 4",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${7.5 * n} Gallons` },
        { column1: "Two Coats", column2: `${10 * n} Gallons` },
        { column1: "Two Coats", column2: `${18 * n} Gallons` },
      ],
    },
  ];
};

export const fifthPickleBallSection = (n) => {
  return [
    {
      name: "Row 5",
      left: [
        "Color /Neutral Concentrate",
        "Color/Neutral Concentrate w/Sand",
        "Ready-Mix Color",
      ],
      right: [
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${5 * n} Gallons` },
        { column1: "Two Coats", column2: `${10 * n} Gallons` },
      ],
    },
  ];
};

export const sixthPickleBallSection = (n) => {
  return [
    {
      name: "Row 6",
      left: [
        "CushionMaster II (Coarse Rubber)",
        "CushionMaster I (Fine Rubber)",
      ],
      right: [
        { column1: "Three Coats", column2: `${90 * n} Gallons` },
        { column1: "Two Coats", column2: `${60 * n} Gallons` },
      ],
    },
  ];
};

export const seventhPickleBallSection = (n) => {
  return [
    {
      name: "Row 7",
      left: ["Covers Border, Play, and Non-Volley"],
      right: [{ column1: "Two Coats", column2: `${30 * n} Gallons` }],
    },
  ];
};

export const eightPickleBallSection = (n) => {
  return [
    {
      name: "Row 8",
      left: [
        "Stripe Rite",
        "White Line Paint",
        "Masking Tape",
        "Standard Size Roll",
      ],
      right: [
        { column1: "One Coat", column2: `${1 * n} Gallons` },
        { column1: "One Coat", column2: `${1 * n} Gallons` },
        { column1: "Rolls Needed", column2: "" },
        { column1: `${6 * n} Rolls`, column2: `` },
      ],
    },
  ];
};

const PickleBallCourt = ({ n }) => {
  const renderCourt = (numberOfCourt) => {
    switch (numberOfCourt) {
      case "one-option":
        return 1;
      case "2-option":
        return 2;
      case "three-option":
        return 3;
      case "four-horizontal-option-2":
        return 4;
      case "four-vertical-option":
        return 4;
      case "five-option-2":
        return 5;
      case "six-horizontal-option-2":
        return 6;
      case "six-vertical-option-3":
        return 6;
      case "seven-option-2":
        return 7;
      case "eight-horizontal-option-2":
        return 8;
      case "eight-vertical-option-2":
        return 8;
      default:
        return 1;
    }
  };

  return (
    <>
      <TennisTable
        rows={secondPickleBallSection(renderCourt(n))}
        leftCol={"Total Area 1800 sq ft / 3600 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={thirdPickleBallSection(renderCourt(n))}
        leftCol={"Total Area / Border 3600 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={forthPickleBallSection(renderCourt(n))}
        leftCol={"Court 1200 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={fifthPickleBallSection(renderCourt(n))}
        leftCol={"Non-Volley Zone 560 sq ft"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={sixthPickleBallSection(renderCourt(n))}
        leftCol={"Pro Cushion Layers (Optional)"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={seventhPickleBallSection(renderCourt(n))}
        leftCol={"Flexible Concentrate Tape"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
      <TennisTable
        rows={eightPickleBallSection(renderCourt(n))}
        leftCol={"Striping"}
        middleCol={"Coats"}
        rightCol={"Gallons Needed"}
      />
    </>
  );
};

export default PickleBallCourt;
